import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Header from './Header/Header'
import ProjectsSearch from './ProjectsSearch/ProjectsSearch'
import ProjectsSearchResults from './ProjectsSearchResults/ProjectsSearchResults'
import CompanyNotFound from './CompanyNotFound/CompanyNotFound'
import Loading from '../Loading/Loading'
import { projectService } from '../../services/apiRemote'
import './Company.css'

const Company = () => {
  let { companyId } = useParams()
  console.log(companyId)
  if (!companyId) {
    companyId = 1
  }
  const [companyData, setCompanyData] = useState(null)
  const [projects, setProjects] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true)
        // Fetch company data
        const companyData = await projectService.getCompanyById(companyId)
        if (!companyData) {
          setError('Company not found')
          setLoading(false)
          return
        }
        setCompanyData(companyData)

        // Fetch company's projects
        const projectsData = await projectService.getProjectsByCompanyId(companyId)
        setProjects(projectsData)

        setLoading(false)
      } catch (err) {
        setError(err.message)
        setLoading(false)
      }
    }

    fetchCompanyData()
  }, [companyId])

  if (loading) return <Loading />
  if (error === 'Company not found') return <CompanyNotFound />
  if (!companyData) return <CompanyNotFound />

  return (
    <div className="companyContainer">
      <Header company={companyData} />
      <ProjectsSearch />
      <ProjectsSearchResults projects={Object.values(projects)} />
    </div>
  )
}

export default Company 